import { getTemplaterResult } from '../getTemplaterResult.function.js';
import { PropWatches } from '../../TagJsTags/tag.function.js';
export function oneRenderToSupport(wrapper, _subject, _ownerSupport) {
    const templater = getTemplaterResult(PropWatches.DEEP);
    templater.tagJsType = wrapper.tagJsType;
    const support = ''; /*newSupportByTemplater(
      templater, ownerSupport, subject
    )*/
    let tag;
    function wrap() {
        templater.tag = tag || wrapper();
        return support;
    }
    templater.wrapper = wrap;
    wrap.tagJsType = wrapper.tagJsType;
    wrap.original = wrapper.original || wrapper;
    return support;
}
